import classNames from 'classnames'

import styles from './b2b-divider.module.scss'

interface B2BDividerProps {
  className?: string
}

export default function B2BDivider({ className }: B2BDividerProps) {
  return <div className={classNames(styles.divider, className)} />
}
